<template>
  <div class="page container-fluid h-100">
    <div class="row no-gutters h-100">
      <div
        class="spec-img col col-lg-4 h-100"
        v-bind:style="{ 'background-image': 'url(\'/assets/specjalnosci_big/' + spec.url_slug + '.jpg\')' }"
      ><img :src="'/assets/specjalnosci_big/' + spec.url_slug + '.jpg'" :title ="spec.title" class="d-none"></div>
      <div class="spec-content col col-lg-8 h-100">
        <div class="spec-nav page-nav row no-padding">
          <div class="col-6 text-left">
            <b-link :to="{ name: 'Specjalizacja', params: { name: spec.prev} }" v-if="spec.prev">
              <font-awesome-icon icon="arrow-left"/>
            </b-link>
          </div>
          <div class="col-6 text-right">
            <b-link :to="{ name: 'Specjalizacja', params: { name: spec.next} }" v-if="spec.next">
              <font-awesome-icon icon="arrow-right"/>
            </b-link>
          </div>
        </div>
        <div class="col no-padding" v-html="spec.content">{{ spec.content }}</div>
        <b-link class="more" :to="{ name: 'Zespol' }">Zespół <font-awesome-icon icon="arrow-right" :style="{ 'margin-left': '2rem', 'color': '#292a2b' }" /></b-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Specjalizacja",
  data() {
    return {
    };
  },
  beforeCreate() {
    if(!this.$store.state.spec) {
      this.$store.dispatch('getSpecs');
    }
  },
  computed: {
      spec() {
        const page = this.$store.getters.getSpec(this.$route.params.name);
        return page;
      }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-height:800px;
}
.spec-img {
  background-repeat: "no-repeat";
  background-size: cover;
  background-position: center center;
  position:absolute;
  top:0;
  left:0;
  opacity:0.1;
}
.spec-content {
  padding: 2rem 3rem;
}

@media (min-width: 960px) {
  .spec-content {
    padding: 4rem 5rem;
  }
  .spec-img {
      position:static;
      opacity:unset;
  }
}
</style>